import React, { ReactNode } from "react";
import Styles from "./HeaderPanel.module.scss";

const HeaderPanel = ({children}: {children: ReactNode}) => (
	<div className={Styles.header_panel}>
		{children}
	</div>
);

export default HeaderPanel;